import React from 'react'

function MenuView() {
    return (
        <div>
            <p>menuView</p>
        </div>
    )
}

export default MenuView
